export const contractTableHeaders = [
  {
    Header: "S.No",
  },
  {
    Header: "Name",
  },
  {
    Header: "Locations",
  },
  {
    Header: "Chargers",
  },
  {
    Header: "Type",
  },
  {
    Header: "Value",
  },
  {
    Header: "Status",
  },
  {
    Header: "Actions",
  },
];

export const userProfilesTableHeaders = [
  {
    Header: "S.No",
  },
  {
    Header: "Name",
  },
  {
    Header: "No Of Users",
  },
  {
    Header: "No Of Chargers",
  },
  {
    Header: "Status",
  },
  {
    Header: "Actions",
  },
];
